import { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Experience from "../components/Experience";
import Specialties from "../components/Specialties";
import Menu from "../components/Menu";
import Bodega from "../components/Bodega";
import WineTasting from "../components/WineTasting";
import Gallery from "../components/Gallery";
import WhyChooseUs from "../components/WhyChooseUs";
import Reservation from "../components/Reservation";
import Location from "../components/Location";
import Newsletter from "../components/Newsletter";
import FAQ from "../components/FAQ";
import AboutUs from "../components/AboutUs";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";

const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F7F2]">
      <Header isScrolled={isScrolled} />
      <main>
        <Hero />
        <Experience />
        <Specialties />
        <Menu />
        <Bodega />
        <WineTasting />
        <Gallery />
        <WhyChooseUs />
        <Reservation />
        <Location />
        <Newsletter />
        <FAQ />
        <AboutUs />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default LandingPage;
